<template>
  <div>
    <div class="comment-infinite-list-wrapper" style="overflow:auto;margin-left: 0px;">
      <ul v-infinite-scroll="getCommentList"
          infinite-scroll-disabled="commentDisabled">

        <div v-if="commentList.length>0">
          <div v-for="(comment, index) in commentList" :key="index">
            <el-container style="width: 100%;margin: 0">
              <el-header height="40" style="text-align: left;padding-top: 10px;">
                <el-row>
                  <el-col :span="2">
                    <!-- 头像-->
                    <div class="avatar-border">
                      <el-avatar v-if="comment.anonymity===0" :src="comment.avatarUrl"></el-avatar>
                      <el-avatar v-if="comment.anonymity===1" icon="el-icon-user-solid"></el-avatar>
                      <div v-if="comment.anonymity===0">
                        <div v-if="comment.utype===2"
                             class="badge-gender" style="background-color:#FF6E40;">v
                        </div>
                        <div v-if="comment.utype===1"
                             class="badge-gender" style="background-color:#3688FF; ">v
                        </div>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <!--昵称 时间 学校-->
                    <div style="display: flow">
                      <div class="title-info">
                        {{ comment.nickname }}
                        <div style="font-size: 13px; ">
                          <div style="float: left;">
                            {{ comment.transformDate }}
                          </div>
                          <div style="color: #42A5F5; float: left; padding-left: 5px;">
                            {{ comment.schoolName }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </el-header>
              <el-main style="text-align: left;padding-top:1px;padding-left:65px;padding-bottom: 10px;">
                <span style="word-break:break-word;" v-html='comment.content'></span>
                <div v-if="comment.replyList.length>0"
                     style="background-color: #F2F6FC;border-radius: 10px;padding: 5px;">
                  <div v-for="(reply, rindex) in comment.replyList" :key="rindex">
                    <el-popover
                        v-if="sthDelete"
                        placement="bottom"
                        width="100"
                        trigger="click">
                      <el-button type="danger" plain size="mini" @click="deleteReply(reply,index,rindex)">删除回复
                      </el-button>
                      <div slot="reference">
                      <span style="color:#409EFF;">
                      {{ reply.fromNickname }}
                    </span>
                        <span v-if="reply.fromUserId!==reply.toUserId && reply.replyId!==0">回复@
                  <span style="color:#409EFF;">{{ reply.toNickname }}</span>
                  </span>
                        <span>: {{ reply.content }}</span>
                      </div>
                    </el-popover>
                    <div v-if="sthDelete===false" slot="reference">
                      <span style="color:#409EFF;">
                      {{ reply.fromNickname }}
                    </span>
                      <span v-if="reply.fromUserId!==reply.toUserId && reply.replyId!==0">回复@
                  <span style="color:#409EFF;">{{ reply.toNickname }}</span>
                  </span>
                      <sapn>: {{ reply.content }}</sapn>
                    </div>
                  </div>
                </div>
              </el-main>
              <div style="padding-bottom: 5px;text-align: right" v-if="sthDelete">
                <el-button type="danger" plain size="mini" @click="deleteComment(comment,index)">删除评论</el-button>
              </div>

              <div style="border-top:solid #F6F7F8 2px;"></div>
            </el-container>
          </div>
        </div>

      </ul>
      <div style="text-align: center">
      <p v-if="commentLoading">加载中...</p>
      <p v-if="commentEmpty">没有更多了</p>
      </div>
    </div>


  </div>
</template>

<script>
export default {
  name: "commentList",
  data() {
    return {
      commentList: [],
      commentId: 0,
      commentCurrentPage: 1,
      commentSize: 20,
      commentEmpty: false,
      commentLoading: false,
      id: 0,
      sthDelete: true
    }
  },
  computed: {
    commentNoMore() {
      return this.commentEmpty
      //return this.count >= 20
    },
    commentDisabled() {
      return this.commentLoading || this.commentNoMore
      //return this.loading || this.empty
    }
  },
  props: {
    dynamicId: 0,
    isDelete: {
      type: Boolean,
      default: false,
    }
  },
  mounted() {
    this.id = this.dynamicId
    this.sthDelete = this.isDelete
  },
  methods: {
    getCommentList: function () {
      if (this.commentEmpty === false) {
        this.commentLoading = true
        this.postRequest('/comment/app/detail?currentPage=' + this.commentCurrentPage + '&size=' + this.commentSize + '&id=' + this.id)
            .then(
                resp => {
                  // this.dynamicLoading = false
                  this.commentLoading = false
                  if (resp) {
                    this.commentList = this.commentList.concat(resp.data);
                    this.commentCurrentPage++;
                    if (resp.data.length === 0) {
                      this.commentEmpty = true
                    }
                  }
                })
      }
    },
    deleteComment(comment, commentIndex) {
      this.$confirm('此操作将永久删除此条评论, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteRequest('/dynamic/web/comment/' + comment.id).then(resp => {
          if (resp) {
            this.commentList.splice(commentIndex, 1);
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    deleteReply(reply, commentIndex, replyIndex) {
      this.$confirm('此操作将永久删除此条回复, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteRequest('/dynamic/web/reply/' + reply.id).then(resp => {
          if (resp) {
            this.commentList[commentIndex].replyList.splice(replyIndex, 1);
            //this.dynamic.commentCount = this.dynamic.commentCount - 1
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
  }
}
</script>

<style scoped>
.infinite-list-wrapper {
  width: 600px;
  height: 700px;
  /*border: 1px solid #eee;*/
}

.comment-infinite-list-wrapper {
  /*width: 600px;*/
  height: 400px;
  /*border: 1px solid #eee;*/
}

.avatar-border {
  width: 60px;
}

.title-info {
  /*width: 400px;*/
  text-align: left;
  word-break: break-word;
  padding-left: 5px;
}

/* 分割线 */
.line {
  height: 10px;
  background-color: #F6F7F8;
}

/* 徽章 */
.badge-gender {
  width: 15px;
  height: 15px;
  border-radius: 15px;
  text-align: center;
  font-size: 15px;
  line-height: 15px;
  position: absolute;
  left: 25px;
  top: 23px;
  z-index: 1;
  border: #FFFFFF solid 2px;
  color: #FFFFFF;
}
</style>
